module.exports = __webpack_public_path__ + "media/theme/Dmm-6836c852.svg";